import styled from 'styled-components';

export const Text = styled.div`
  font-weight: bold;
  color: black;
  word-break: normal;
  /* width: ${({ customwidth }) => customwidth ?? '7em'}; */
  word-wrap: break-word;
`;
